<template>
    <div class="role_warp">
      <!-- 头部工具栏 -->
      <div class="role_heard_tool">
        <el-button
          type="success"
          size="mini"
          @click="getDate()"
          >刷新</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="margin-left: 10px"
          @click="select()"
          >筛选</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="
            margin-left: 10px;
            background: #06cc00;
            border: 1px solid #06cc00;
          "
          @click="getZhuanList(1)"
          >批量立即转账</el-button
        >
        <el-button
          type="primary"
          class="edit-button"
          size="mini"
          style="
            margin-left: 10px;
            background: #6663FF;
            border: 1px solid #6663FF;
          "
          @click="resetStatus()"
          >重置转账状态</el-button
        >
      </div>
      <div class="head_search">
        <div class="item_warp">
          <label style="margin: 0 10px">用户</label>
          <el-input
            v-model="uid"
            placeholder="请输入用户"
            style="width: 120px"
            size="mini"
            clearable
          />
        </div>
        <div class="item_warp">
          <label style="width: 44px">状态</label>
          <el-select v-model="checkStatus" placeholder="请选择" clearable>
            <el-option label="不限" value=""></el-option>
            <el-option label="未转账" value="0"></el-option>
            <el-option label="转账中" value="3"></el-option>
            <el-option label="已转账" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
            <el-option label="转账失败" value="4"></el-option>
          </el-select>
        </div>
      </div>
      <!-- 表单 -->
      <el-table
        ref="gridTable"
        v-loading="loading"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        height="calc(100vh - 240px )"
        style="width: 1781px"
        size="mini"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          :selectable="checkSelectable"
        />
        <el-table-column prop="memberUid" label="用户" width="100" />
        <el-table-column prop="address" label="转账状态" width="170">
          <template slot-scope="scope">
            <div>
              <div
                class=""
                v-if="scope.row.status != 1 && scope.row.status != 2 && scope.row.status != 3 && scope.row.status != 4"
              >
                  <el-button
                  type="primary"
                  class="edit-button"
                  style="background: #06cc00; border: none"
                  size="mini"
                  @click="getMemberTiePass(scope.row,2)"
                  >立即转账</el-button
                >
                  <el-button
                  type="primary"
                  class="edit-button"
                  style="background: #ff0000; border: none"
                  size="mini"
                  @click="memberTieReject(scope.row)"
                  >拒绝转账</el-button
                >
              </div>
              <div v-if="scope.row.status == 1" style="color: #06cc00">
                已转账
              </div>
              <div v-if="scope.row.status == 2" style="color: #ff0000">
                已拒绝
              </div>
              <div v-if="scope.row.status == 3" style="color: #ccc">
                转账中
              </div>
              <div v-if="scope.row.status == 4" style="color: #ff0000">
                转账失败X{{scope.row.failCount}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="领取金额" width="100" />
        <el-table-column prop="network" label="提现网络" width="100" />
        <el-table-column prop="address" label="提现地址" width="150" />
        <el-table-column prop="hashid" label="转账hashid" width="150" />
        <el-table-column prop="fromAddress" label="转出地址" width="150" />
        <el-table-column prop="address" label="转出时间" width="100">
          <template slot-scope="scope">
            <div>
              <div>
                {{ scope.row.tranPassDate?happenTimeFun(scope.row.tranPassDate):'' }}
              </div>
              
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="memo" label="备注" width="100" />
        <el-table-column prop="createDate" label="创建时间" width="170" />
      </el-table>
      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="getList"
      />
      <!-- 归集主账号 -->
      <el-dialog
        :visible.sync="editPasswordShow"
        width="400px"
        :center="true"
        title="主账号选择"
        :close-on-click-modal="false"
      >
        <div>
          <div style="margin: 15px 0" class="radioGroup">
            <el-radio-group v-model="masterAccountId">
              <el-radio style="white-space: break-spaces;" v-for="(item,index) in masterAccountList" :key="index" :label="item.id">
                {{item.address}}<span v-if="item.memo" style="margin-left: 10px;">({{item.memo}})</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 1">
            <el-button
              type="primary"
              class="edit-button"
              @click="checkSuccessList()"
              >确定</el-button
            >
          </div>
          <div style="display: flex;justify-content: center;" v-if="type == 2">
            <el-button
              type="primary"
              class="edit-button"
              @click="memberTiePass()"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  import Pagination from "@/components/Pagination"; // 引入分页器
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  import validEmail from "@/utils/validate"; // 引入邮箱验证方法
  import md5 from "js-md5"; // 引入Md5加密
  
  export default {
    name: "Management",
    components: { Pagination, VueUeditorWrap },
    data() {
      return {
        tableData: [], // 展示的表单信息
        total: 0, // 总数
        pageNum: 1, // 页码值
        pageSize: 20, // 页大小
        loading: false, // 表格加
        uid: "",
        address: "",
        ipAddress: "",
        checkStatus: "",
        ip: "",
        yifangUsername: "",
        dataTime: ["", ""],
        amount: "",
        chargeFee: "",
        active: {},
        count: 0,
        editDialogVisible: false,
        editPasswordShow: false,
        masterAccountId:'',
        id:'',
        type:1,
        masterAccountList:[],
        multipleSelection:[],
        bool:false
      };
    },
    mounted() {
      this.getDate();
      // this.autoShenhe();
    },
    methods: {
      totalAmount(){
        var params = {
          pageNumber: this.pageNum,
          pageSize: this.pageSize,
          uid: this.uid,
          status: this.checkStatus,
          address: this.address
        };
        this.$api.capital
          .withdrawTransferTotalAmount(params)
          .then((res) => {
            this.amount = res.amount;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      editClose() {},
      getZhuanList() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        this.type = 1 
        this.$api.operate
          .masterAccountsTrx()
          .then((res) => {
            if(res.length > 0){ 
              this.bool = false
              this.editPasswordShow = true
              this.masterAccountList = res
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      resetStatus() {
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString()
          };
        this.$api.operate
          .memberShareWithdrawTrxTesetStatus(params)
          .then((res) => {
            if(res.length > 0){ 
               this.$message.success(res);
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
            this.getList()
          });
      },
      happenTimeFun(num) {
        let date = new Date(num);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      // 自动审核设置 更新接口：
      updateAutoShenhe() {
        this.$api.capital
          .updateAutoZhuan(this.active)
          .then((res) => {
            this.$message.success(res);
            this.autoShenhe();
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
            this.autoShenhe();
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 自动审核设置 回显接口：
      autoShenhe() {
        this.$api.capital
          .autoZhuan()
          .then((res) => {
            this.active = res;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
      // 选择或者取消行，支持全选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      checkSelectable(row) {
        // if (row.status == 0 || row.status == 4) {
        //   return true;
        // } else {
        //   return false;
        // }
        return true;
      },
      getMemberTiePass(row){
        this.id = row.id
        this.type = 2 
        this.$api.operate
          .masterAccountsTrx()
          .then((res) => {
            if(res.length > 0){
              this.editPasswordShow = true
              this.masterAccountList = res
            }else{
              this.$message.info("暂无主体");
            }
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
  
  
      },
      // 通过转账
      memberTiePass(row) {
        if(this.bool) return;
        this.bool = true
         var ids = [this.id];
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.operate
            .zhuanListTrx(params)
            .then((res) => {
              this.$message.success(res);
              this.bool = false
              this.editPasswordShow = false
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
             
      },
      // 拒绝转账
      memberTieReject(row) {
        this.$confirm("是否拒绝转账?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var ids = [row.id];
            this.$api.operate
              .memberShareWithdrawTrxRejectList({
                ids: ids.toString(),
              })
              .then((res) => {
                this.$message.success(res);
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err || "服务器错误，请稍后重试");
              })
              .finally(() => {
  
              });
          })
          .catch(() => {
            
          });
      },
      // 批量转账
      checkSuccessList() {
        if(this.bool) return;
        this.bool = true
        var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
            masterAccountId:this.masterAccountId
          };
          this.$api.operate
            .zhuanListTrx(params)
            .then((res) => {
              this.$message.success(res);
              this.bool = false
              this.editPasswordShow = false
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
      },
      applyCount() {
        this.checkStatus = "0";
        this.select();
      },
      // 筛选
      select() {
        this.pageNum = 1;
        this.getList();
      },
      getDate() {
        this.getList();
      },
      // 获取表单信息
      getList() {
        var params = {
          pageNumber: this.pageNum, 
          pageSize: this.pageSize,
          uid: this.uid,
          status: this.checkStatus,
          address: this.address
        };
        this.loading = true;
        this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
          .memberShareWithdrawTrx(params)
          .then((res) => {
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch((err) => {
            this.$message.error(err || "服务器错误，请稍后重试");
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .role_warp {
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    .role_heard_tool {
      margin-bottom: 10px;
    }
    .edit_titile {
      .dialog_input {
        // width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        span {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-right: 20px;
        }
        .el-input {
          flex: 3;
        }
      }
    }
    .tree {
      margin-top: 25px;
      display: flex;
      justify-content: space-around;
    }
    .authority_info {
      margin-top: 25px;
    }
  }
  .el-input {
    width: 70%;
  }
  .content {
    border: 2px dashed #000;
    padding-left: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  // ::v-deep .radioGroup .el-radio-group{
  //   display: flex;
  //     flex-direction: column;
  // }
  // ::v-deep .radioGroup .el-radio{
  //   margin-bottom: 10px;
  // }
  ::v-deep .el-radio{
    margin-bottom: 10px !important;
  }
  </style>
  